import { drama } from '../../../../constants/actionTypes';

export default (state = false, action) => {
  switch (action.type) {
    case drama.FETCH_DRAMA_COMMENTS:
    return true;

    case drama.FETCH_DRAMA_COMMENTS_SUCCESS:
    case drama.FETCH_DRAMA_COMMENTS_FAILED:
      return false;

    default:
      return state;
  }
};
